import { parseAmountInput } from '../../../../../common/core/amountInput'
import { Liable, Remedy } from '../../../../settlement'
import { PayoutCulpritFacts } from './requests.types'
import { CulpritCandidate } from './response.types'

// What the operator enters for one culprit deposit of a payout dispute.
export interface CulpritDraft {
  paid: string
  liable: Liable | null
  remedy: Remedy | null
}

export const EMPTY_DRAFT: CulpritDraft = { paid: '', liable: null, remedy: null }

// unknown — nothing entered yet; missing — the client got less than it was owed; arrivedLater — more
// than the remedies assumed (the corrections are undone); none — nothing to do for this deposit.
export type ShortfallState = 'unknown' | 'missing' | 'arrivedLater' | 'none'

export const openShortfall = (candidate: CulpritCandidate, draft: CulpritDraft): number =>
  Number(candidate.body) - Number(candidate.remedied) - (parseAmountInput(draft.paid) ?? 0)

export const shortfallState = (
  candidate: CulpritCandidate,
  draft: CulpritDraft
): ShortfallState => {
  if (parseAmountInput(draft.paid) === null) return 'unknown'
  const open = Math.round(openShortfall(candidate, draft) * 100) / 100
  if (open > 0) return 'missing'
  if (open < 0) return 'arrivedLater'
  return 'none'
}

export const draftComplete = (candidate: CulpritCandidate, draft: CulpritDraft): boolean => {
  const state = shortfallState(candidate, draft)
  return (
    state !== 'unknown' && (state !== 'missing' || (draft.liable !== null && draft.remedy !== null))
  )
}

export const toCulpritFacts = (
  candidates: CulpritCandidate[],
  drafts: Record<string, CulpritDraft>
): PayoutCulpritFacts[] =>
  candidates.map((candidate) => {
    const draft = drafts[candidate.token] ?? EMPTY_DRAFT
    const facts: PayoutCulpritFacts = {
      token: candidate.token,
      paidAmount: parseAmountInput(draft.paid) ?? 0,
    }
    if (shortfallState(candidate, draft) === 'missing' && draft.liable && draft.remedy) {
      facts.liable = draft.liable
      facts.remedy = draft.remedy
    }
    return facts
  })
